import React, { useRef } from "react"
import "twin.macro"
import { ReactComponent as HeartOutlineEmojiSVG } from "../../assets/icons/heart-outline-emoji.svg"
import { useClickOutside } from "../../utils/hooks/useClickOutside"
import { EmojiPanelWrapper, getEmojiForReaction } from "."
import { EmojiPanel, EmojiPanelProps } from "./emojiPanel"

export const AddReaction = (props: EmojiPanelProps) => {
  const { userEmoji, setShowEmojiPanel, showEmojiPanel } = props

  const ref = useRef(null)
  useClickOutside(ref, () => setShowEmojiPanel(false))

  const userReactionElement = userEmoji ? (
    <span data-testid="user-reaction">{getEmojiForReaction(userEmoji)}</span>
  ) : (
    <span aria-label={`add a reaction`}>
      <HeartOutlineEmojiSVG />
    </span>
  )

  return (
    <div tw="relative" ref={ref}>
      <div
        tw="text-3xl cursor-pointer"
        data-testid="reaction-toggle-panel"
        onClick={() => setShowEmojiPanel(!showEmojiPanel)}
      >
        {userReactionElement}
      </div>
      <EmojiPanelWrapper isOpen={showEmojiPanel}>
        <EmojiPanel {...props} />
      </EmojiPanelWrapper>
    </div>
  )
}
